import SectionHeading from './SectionHeading';
import { storyMainline, synopsisHighlights, synopsisParagraphs } from '@/mocks/synopsis';

export default function SynopsisSection() {
  return (
    <section id="synopsis" className="scroll-mt-24 bg-background-100 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="Synopsis"
          title="故事梗概：一场同学会如何一步步失控"
          desc="先看整体走向，再往下看细节。以下内容按主线脉络展开，不重复堆砌同一段介绍。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="space-y-5 lg:col-span-2">
            {synopsisParagraphs.map((para, index) => (
              <p key={index} className="text-sm leading-loose text-foreground-700 md:text-base">
                {para}
              </p>
            ))}
          </div>

          <div className="space-y-4">
            {synopsisHighlights.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12">
          <h3 className="font-heading text-lg font-semibold text-foreground-950 md:text-xl">主线四幕</h3>
          <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {storyMainline.map((item, index) => (
              <div
                key={item.stage}
                className="relative rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
              >
                <span className="font-heading text-3xl font-black text-background-300">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <p className="mt-2 font-label text-xs uppercase tracking-wider text-primary-600">{item.stage}</p>
                <h4 className="mt-2 font-heading text-base font-semibold text-foreground-950">
                  <a href="#episodes" className="transition-colors hover:text-primary-600">
                    {item.title}
                  </a>
                </h4>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}